import { ITreatment } from './Treatment.types';

export const initialTreatment : ITreatment = {
  date: null,
  treatment: ""
}